import { object } from 'valibot'

import { stringToNumber } from '@/libs/valibot'

export const siteParamsSchema = object({
  siteId: stringToNumber()
})
